var map = {
	"./add-file.png": "03e1",
	"./astropay_icon.png": "914a",
	"./astropay_select.png": "b89f",
	"./bank_transfer_icon.png": "e615",
	"./bank_transfer_select.png": "402c",
	"./bitcoin_icon.png": "35c6",
	"./bitcoin_select.png": "ec0f",
	"./bitwallet_icon.png": "3cfb",
	"./close.png": "2a2b",
	"./cn_icon.png": "a78b",
	"./cn_select.png": "d8cc",
	"./eth_icon.png": "b7ba",
	"./eth_select.png": "5532",
	"./fasapay_icon.png": "9db0",
	"./fasapay_select.png": "2487",
	"./info.png": "746d",
	"./interac.png": "93ca",
	"./interac_icon.png": "ce4d",
	"./jcb_icon.png": "cab9",
	"./jcb_select.png": "cdd3",
	"./master_card.png": "b5ad",
	"./master_card_icon.png": "6a71",
	"./master_card_select.png": "10b3",
	"./neteller_icon.png": "5663",
	"./neteller_select.png": "a168",
	"./nigeria_icon.png": "31c9",
	"./nigeria_select.png": "41eb",
	"./perfect_money_icon.png": "076c",
	"./perfect_money_select.png": "f997",
	"./select-down-circle.png": "01a8",
	"./select-down.png": "8f64",
	"./select-up-circle.png": "fec0",
	"./select-up.png": "9fdc",
	"./skrill_icon.png": "9644",
	"./skrill_select.png": "18d7",
	"./sticpay_icon.png": "442a",
	"./sticpay_select.png": "1a149",
	"./swift_icon.png": "dfeb",
	"./swift_select.png": "3e08",
	"./tai_icon.png": "4c25",
	"./tai_select.png": "99dd",
	"./union_pay_icon.png": "05cf",
	"./union_pay_select.png": "2d01",
	"./upi_icon.png": "662f",
	"./upi_select.png": "db08",
	"./usdc_icon.png": "347f",
	"./usdc_select.png": "bd24",
	"./usdt_icon.png": "2500",
	"./usdt_select.png": "f319",
	"./vietna_icon.png": "935c",
	"./vietna_select.png": "1ac2",
	"./visa_card.png": "2731",
	"./visa_icon.png": "5e21",
	"./visa_select.png": "a8b3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "84a8";